<template>
	<div>
		<div v-for="(feeObj, feeObj_i) in fees" :key="feeObj_i" class="row mb-2">
			<div class="col-4">
				<div class="body-strong text-grey-900 text-start text-nowrap">
					{{ content[`planner_resumeFee_${feeObj.name}`] }}
				</div>
			</div>
			<div class="col-8">
				<div class="body-strong text-grey-900 text-end">
					<span class="me-1">+</span>
					<span>{{
						displayPrice(parseInt(feeObj.value * 100), locale, 1)
					}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import displayPrice from "@/displayPrice/displayPrice";
import store from "@/vue/planning/store/store";

export default {
	store,
	name: "Fees",
	components: {},
	computed: {
		...mapState(["content"]),
		...mapGetters(["fees", "locale"]),
	},
	methods: {
		displayPrice,
	},
};
</script>

<style scoped></style>
